import FAQ, { TypeType } from 'components/faq/FAQ';
import LandingHero from 'components/landingHero/LandingHero';
import Quote from 'components/quote/Quote';
import faqs from 'modules/faqs';
import { userBasicInfoPublicPages } from 'modules/graphqlQueries';
import { useRouter } from 'next/router';
import {
  Bullet,
  BulletPoint,
  BulletsPoints,
  BulletText,
  ButtonStyled,
  QuoteWrapper,
  ScreenImage,
  SectionsTitle,
  SectionsTitleWrapper,
  SubTitle,
  TitleLine,
  WhatWeProvide,
  WhatWeProvideContent,
} from 'styles/service-suppliers.styles';

import Layout from '../components/layout/Layout';
import { useLoadData } from '../modules/useLoadData';
import { UserType } from '../types/UserTypes';

const getQuery = (userId) => `{
  user(_id: "${userId}") {
    ${userBasicInfoPublicPages}
  }
}`;

const Suppliers = (): JSX.Element => {
  const router = useRouter();

  const {
    isLoading,
    response: {
      data: { user },
    },
  } = useLoadData(getQuery);

  const faqsShipManagers = faqs.filter((faq) =>
    faq.type.includes(TypeType.MANAGER)
  );

  return (
    <Layout user={user as UserType} isLoading={isLoading}>
      <LandingHero
        image="/shipManagers.webp"
        title="Make your technical service easy"
        // text="Select the machinery item you want to service. Describe the service you need, when and where. Select the best offer. Done. Join bid2board and do it that easy
        text="Keep all your machinery details in one place.
        Have all possible service suppliers ranked.
        Complete all your technical services with a few clicks.
        Join bid2board and do it that easy"
        buttons={[
          {
            kind: 'request',
            text: 'Contact us',
            onClick: () => router.push('/contact'),
          },
        ]}
      />
      <WhatWeProvide>
        <SectionsTitleWrapper>
          <SectionsTitle color="black">What we provide</SectionsTitle>
          <SubTitle>TO SHIP MANAGERS</SubTitle>
        </SectionsTitleWrapper>
        <TitleLine color="gray" />
        <WhatWeProvideContent>
          <BulletsPoints>
            <BulletPoint>
              <Bullet>1</Bullet>
              <BulletText>
                Simplification and reduction of the time required for service
                arrangement
              </BulletText>
            </BulletPoint>
            <BulletPoint>
              <Bullet>2</Bullet>
              <BulletText>
                Choice between a large number of verified local and travelling
                suppliers
              </BulletText>
            </BulletPoint>
            <BulletPoint>
              <Bullet>3</Bullet>
              <BulletText>
                Cost savings through a bidding process for each service request
              </BulletText>
            </BulletPoint>
            <BulletPoint>
              <Bullet>4</Bullet>
              <BulletText>Data analytics and benchmarking</BulletText>
            </BulletPoint>
            <BulletPoint>
              <Bullet>5</Bullet>
              <BulletText>
                Time and resources allocation efficiencies
              </BulletText>
            </BulletPoint>
            <BulletPoint>
              <Bullet>6</Bullet>
              <BulletText>Service suppliers assessment tool</BulletText>
            </BulletPoint>
          </BulletsPoints>
          <ScreenImage src="/screenCreateSR.png" />
        </WhatWeProvideContent>
        {/* <Quote title="Our Vision">
          Bringing digital transformation to the industry by ultimately fully
          integrating our Platform in the Managment System of shipping companies
          towards creating new and sustainable processes in service provision.
        </Quote> */}
      </WhatWeProvide>
      <FAQ faqs={faqsShipManagers} />
      <QuoteWrapper>
        <Quote title="Benefits">
          Keep all your machinery details in one place. Have all possible
          service suppliers ranked. Complete all your technical services with a
          few clicks. Join bid2board and do it that easy
        </Quote>
        <ButtonStyled
          kind="primary"
          text="Contact us"
          onClick={() => router.push('/contact')}
          icon="rightArrow"
        />
      </QuoteWrapper>
    </Layout>
  );
};

export default Suppliers;
